export type SearchColor = 'blue' | 'cyan' | 'emerald' | 'green' | 'indigo' | 'orange' | 'pink' | 'purple' | 'teal';

export const SEARCH_PALETTE: Record<
  SearchColor,
  { highlighted: string; hover: string; iconBox: string; icon: string; badge: string; count: string }
> = {
  blue: {
    highlighted: 'from-blue-50 dark:from-blue-900/20 border-l-blue-500',
    hover: 'hover:border-l-blue-300 dark:hover:border-l-blue-700',
    iconBox:
      'from-blue-100 to-blue-50 dark:from-blue-900/30 dark:to-blue-800/20 ring-blue-200/50 dark:ring-blue-700/50',
    icon: 'text-blue-600 dark:text-blue-400',
    badge: 'bg-blue-100 dark:bg-blue-900/30',
    count: 'text-blue-700 dark:text-blue-300',
  },
  cyan: {
    highlighted: 'from-cyan-50 dark:from-cyan-900/20 border-l-cyan-500',
    hover: 'hover:border-l-cyan-300 dark:hover:border-l-cyan-700',
    iconBox:
      'from-cyan-100 to-cyan-50 dark:from-cyan-900/30 dark:to-cyan-800/20 ring-cyan-200/50 dark:ring-cyan-700/50',
    icon: 'text-cyan-600 dark:text-cyan-400',
    badge: 'bg-cyan-100 dark:bg-cyan-900/30',
    count: 'text-cyan-700 dark:text-cyan-300',
  },
  emerald: {
    highlighted: 'from-emerald-50 dark:from-emerald-900/20 border-l-emerald-500',
    hover: 'hover:border-l-emerald-300 dark:hover:border-l-emerald-700',
    iconBox:
      'from-emerald-100 to-emerald-50 dark:from-emerald-900/30 dark:to-emerald-800/20 ring-emerald-200/50 dark:ring-emerald-700/50',
    icon: 'text-emerald-600 dark:text-emerald-400',
    badge: 'bg-emerald-100 dark:bg-emerald-900/30',
    count: 'text-emerald-700 dark:text-emerald-300',
  },
  green: {
    highlighted: 'from-green-50 dark:from-green-900/20 border-l-green-500',
    hover: 'hover:border-l-green-300 dark:hover:border-l-green-700',
    iconBox:
      'from-green-100 to-green-50 dark:from-green-900/30 dark:to-green-800/20 ring-green-200/50 dark:ring-green-700/50',
    icon: 'text-green-600 dark:text-green-400',
    badge: 'bg-green-100 dark:bg-green-900/30',
    count: 'text-green-700 dark:text-green-300',
  },
  indigo: {
    highlighted: 'from-indigo-50 dark:from-indigo-900/20 border-l-indigo-500',
    hover: 'hover:border-l-indigo-300 dark:hover:border-l-indigo-700',
    iconBox:
      'from-indigo-100 to-indigo-50 dark:from-indigo-900/30 dark:to-indigo-800/20 ring-indigo-200/50 dark:ring-indigo-700/50',
    icon: 'text-indigo-600 dark:text-indigo-400',
    badge: 'bg-indigo-100 dark:bg-indigo-900/30',
    count: 'text-indigo-700 dark:text-indigo-300',
  },
  orange: {
    highlighted: 'from-orange-50 dark:from-orange-900/20 border-l-orange-500',
    hover: 'hover:border-l-orange-300 dark:hover:border-l-orange-700',
    iconBox:
      'from-orange-100 to-orange-50 dark:from-orange-900/30 dark:to-orange-800/20 ring-orange-200/50 dark:ring-orange-700/50',
    icon: 'text-orange-600 dark:text-orange-400',
    badge: 'bg-orange-100 dark:bg-orange-900/30',
    count: 'text-orange-700 dark:text-orange-300',
  },
  pink: {
    highlighted: 'from-pink-50 dark:from-pink-900/20 border-l-pink-500',
    hover: 'hover:border-l-pink-300 dark:hover:border-l-pink-700',
    iconBox:
      'from-pink-100 to-pink-50 dark:from-pink-900/30 dark:to-pink-800/20 ring-pink-200/50 dark:ring-pink-700/50',
    icon: 'text-pink-600 dark:text-pink-400',
    badge: 'bg-pink-100 dark:bg-pink-900/30',
    count: 'text-pink-700 dark:text-pink-300',
  },
  purple: {
    highlighted: 'from-purple-50 dark:from-purple-900/20 border-l-purple-500',
    hover: 'hover:border-l-purple-300 dark:hover:border-l-purple-700',
    iconBox:
      'from-purple-100 to-purple-50 dark:from-purple-900/30 dark:to-purple-800/20 ring-purple-200/50 dark:ring-purple-700/50',
    icon: 'text-purple-600 dark:text-purple-400',
    badge: 'bg-purple-100 dark:bg-purple-900/30',
    count: 'text-purple-700 dark:text-purple-300',
  },
  teal: {
    highlighted: 'from-teal-50 dark:from-teal-900/20 border-l-teal-500',
    hover: 'hover:border-l-teal-300 dark:hover:border-l-teal-700',
    iconBox:
      'from-teal-100 to-teal-50 dark:from-teal-900/30 dark:to-teal-800/20 ring-teal-200/50 dark:ring-teal-700/50',
    icon: 'text-teal-600 dark:text-teal-400',
    badge: 'bg-teal-100 dark:bg-teal-900/30',
    count: 'text-teal-700 dark:text-teal-300',
  },
};
